import * as Types from 'src/actions/investor-type/change-data/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import InvestorType from 'src/entities/InvestorType';

export interface ChangeInvestorType extends Action {
  type: Types.CHANGE_INVESTOR_TYPE_DATA;
  payload: InvestorType;
}

export type ChangeInvestorTypeAction = ChangeInvestorType;

export const changeInvestorType: ActionCreator<ChangeInvestorType> =
  (investorType: InvestorType) => (
    {
      type: Types.CHANGE_INVESTOR_TYPE_DATA,
      payload: investorType
    }
  );


// WEBPACK FOOTER //
// ./src/actions/investor-type/change-data/ChangeInvestorType.actions.tsx